<template>
  <v-container class="pa-0 mt-1 d-flex align-start" :style="{ maxWidth: maxWidth + 'px' }">
    <v-card tile class="rounded-lg" width="100%"
      :height="$vuetify.breakpoint.height - 100 + 'px'">
      <v-card-title class="primary white--text pa-1">
        <v-btn icon dark to="/">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
        <span class="ml-2">Networking Room</span>
        <v-spacer></v-spacer>
       <Header/>
      </v-card-title>
      <v-card-text class="pa-0 rounded-lg card-relative">
      <v-row no-gutters>
        <v-col cols="9">
          <v-card class="pa-2" flat tile >
            <v-card-subtitle class="pa-2">
              <v-row dense>
                <v-col cols="1" align-self="center" class="text-right mr-1">
                  Attendee
                </v-col>
                <v-col cols="3" align-self="center" class="text-right">
                  <v-row dense>
                    <v-text-field
                      v-model="search"
                      v-debounce:300ms="searchAttendee"
                      outlined
                      placeholder="Attendee Name"
                      hide-details
                      dense
                      clearable
                      @click:clear="clearSearch()"
                      append-icon="mdi-magnify"
                    ></v-text-field>
                  </v-row>
                </v-col>
                <v-col cols="2" align-self="center" class="text-right mr-1">
                  Organization Type
                </v-col>
                <v-col cols="3" align-self="center" class="text-right">
                    <v-select
                      v-model="selected_category"
                      outlined
                      dense
                      :items="category_list"
                      item-text="name"
                      item-value="category_id"
                      placeholder="Category"
                      hide-details
                      @change="searchAttendee"
                    ></v-select>
                </v-col>
                <v-col cols="2" class="text-right">
                  <v-btn-toggle
                    mandatory
                  >
                    <v-btn @click="is_list_view = true">
                      <v-icon>mdi-view-list</v-icon>
                    </v-btn>
                    <v-btn @click="is_list_view = false">
                      <v-icon>mdi-view-grid</v-icon>
                    </v-btn>
                  </v-btn-toggle>
                </v-col>
              </v-row>
            </v-card-subtitle>
            <v-card-text style="overflow-y:scroll" :style="{maxHeight : ($vuetify.breakpoint.height - 235)+'px'}">
              <v-list v-if="is_list_view">
                <div v-for="(item, index) in attendee_list" :key="index">
                  <v-list-item>
                    <v-list-item-avatar>
                      <v-img :src="item.profile_pic"></v-img>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title v-html="item.full_name"></v-list-item-title>
                      <v-list-item-subtitle class="mt-1">
                        {{item.company_name}}<span v-if="item.designation"> - {{item.designation}}</span>
                        <span v-if="item.online_status">
                          - <span v-html="item.display_online_status"></span>
                        </span>
                      </v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-row>
                        <v-btn icon @click="startChatWithAttendee(item)">
                          <v-icon color="grey darken-3"
                            >mdi-message-text-outline</v-icon
                          >
                        </v-btn>
                        <v-btn icon target="_blank" :href="item.linkedin_url" v-if="item.linkedin_url">
                          <v-icon color="light-blue darken-4">mdi-linkedin</v-icon>
                        </v-btn>
                      </v-row>
                    </v-list-item-action>
                  </v-list-item>
                  <v-divider
                    v-if="index != attendee_list.length - 1"
                  ></v-divider>
                </div>
              </v-list>

              <v-row v-if="!is_list_view">
                <v-col cols="4" v-for="(item, index) in attendee_list" :key="index">
                  <v-card
                    outlined
                  >
                    <v-list-item three-line>
                      <v-list-item-content>
                        <v-list-item-title class="headline mb-1">
                          {{item.full_name}}
                        </v-list-item-title>
                        <v-list-item-subtitle class="mt-1">
                          {{item.company_name}}
                        </v-list-item-subtitle>
                        <v-list-item-subtitle class="mt-1" v-if="item.designation">
                          {{item.designation}}
                        </v-list-item-subtitle>
                        <v-list-item-subtitle class="mt-1" v-if="item.online_status">
                          <span v-html="item.display_online_status"></span>
                        </v-list-item-subtitle>
                      </v-list-item-content>


                      <v-list-item-avatar
                        size="80">
                        <v-img :src="item.profile_pic"></v-img>
                      </v-list-item-avatar>
                    </v-list-item>



                    <v-card-actions>
                      <v-btn icon @click="startChatWithAttendee(item)">
                        <v-icon color="grey darken-3"
                          >mdi-message-text-outline</v-icon
                        >
                      </v-btn>
                      <v-btn icon target="_blank" :href="item.linkedin_url" v-if="item.linkedin_url">
                        <v-icon color="light-blue darken-4">mdi-linkedin</v-icon>
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-col>
              </v-row>

              <div v-if="attendee_list.length == 0">
                No Attendee Found!
              </div>

              <div v-if="total_attendees >= 25 && total_attendees > attendee_start_from" class="text-center">
                <v-btn
                  elevation="2"
                  small
                  class="text-capitalize"
                  @click="loadMore"
                >Load More</v-btn>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="3" class="pa-1">
          <div class="d-flex align-center" :style="{height : '100%'}">
            <div class="d-flex flex-column self-center" style="width:100%">
              <v-card class="pa-2" outlined tile @click="$helper.openUrl(object_list.ADVERTISE_1.link)" :ripple="object_list.ADVERTISE_1.link!=null">
                <v-img :src="object_list.ADVERTISE_1.upload_url" max-height="230" contain></v-img>
              </v-card>
              <v-card class="pa-2" outlined tile @click="$helper.openUrl(object_list.ADVERTISE_2.link)" :ripple="object_list.ADVERTISE_2.link!=null">
                <v-img :src="object_list.ADVERTISE_2.upload_url" max-height="230" contain></v-img>
              </v-card>
            </div>
          </div>
        </v-col>
      </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
import axios from "@/helper/axios";
import { mapState,mapMutations } from "vuex";
import Header from '@/components/afterAuth/Header.vue'
export default {
  name: "SessionList",
  components : {
    Header
  },
  data() {
    return {
      delay : 3000,
      search : '',
      is_list_view: true,
      selected_category : '',
      total_attendees: 0,
      category_list: [],
      attendee_list: [],
      attendee_start_from: 0,
      object_list: {
        ADVERTISE_1:{},
        ADVERTISE_2:{}
      },
    };
  },
  computed: {
    ...mapState("utils", ["maxWidth",'pageBackgroundImage']),
  },
  methods: {
    ...mapMutations("utils", ["setBackground"]),
    ...mapMutations("notifications", ["setExpandBox","setTempPrivateMessage","setChatPrivate","setPrivateChatUser"]),
    clearSearch(){
      this.search = '';
      this.attendee_start_from = 0
      this.getVendorList()
    },
    startChatWithAttendee(attendee) {
      this.setChatPrivate(true)
      this.setTempPrivateMessage(attendee)
      this.setPrivateChatUser(attendee)
      this.setExpandBox(0)
    },
    searchAttendee(){
      this.attendee_start_from = 0
      this.getVendorList()
    },
    getVendorList() {
      let _self = this;
      axios.get("/attendee/list?search="+_self.search+'&category='+_self.selected_category+"&start_from="+_self.attendee_start_from)
        .then(function (response) {
          if(_self.attendee_start_from > 0) {
             _self.attendee_list.push(...response.data.data)
          } else {
            _self.attendee_list = response.data.data;
          }
          _self.total_attendees = response.data.totalRecord
        })
        .catch(function (e) {
          console.log(e);
        });
    },
    getObjects() {
      let _self = this;
      axios.get("object/get?page_name=NETWORKING_ROOM")
        .then(function (response) {
          for (let key in response.data.data) {
            let data = response.data.data[key];
            _self.object_list[data.page_position[0].value] = data;
          }
        })
        .catch(function (e) {
          console.log(e);
        });
      _self.loading = false;
    },
    getCategoryList() {
      let _self = this;
      axios.get("organization/list")
      .then(function (response) {
        _self.category_list = response.data.data;
        _self.category_list.unshift({name : 'All' , category_id : ''})
      })
      .catch(function (e) {
        console.log(e);
      });
    },
    loadMore(){
      this.attendee_start_from = this.attendee_start_from + 25
      this.getVendorList()
    }
  },
  mounted() {
    this.getCategoryList()
    this.getVendorList();
    this.getObjects()
    this.setBackground({
      image : 'url("'+process.env.VUE_APP_ASSETS+'networking_lounge_background.png")'
    })
  },
  destroyed(){
    this.setBackground({
      image : ''
    })
  }
};
</script>
<style>
</style>